import ApiService from "../../../core/services/ApiService";
import Swal from "sweetalert2";

/* eslint-disable */
function initialState() {
  return {
    dresscodesList: [],
    loading: false,
    error: '',
    pagination: {
      current_page: 1,
      last_page: 1
    }
  }
}

const getters = {
  dresscodesList: state => state.dresscodesList,
  getPaginationData: state => state.pagination,
  loading: state => state.loading
}

const actions = {
  fetchData({commit, state}) {
    commit('setLoading', true);

    ApiService.get('api/v2',
        'dresscodes?page=' + state.pagination.current_page + '&perPage=10')
        .then(
        response => {
          commit('setDresscodesList' , response.data.data)
          commit("setPagination", response.data)
        }).catch(error => {
      commit('setError', error)
      console.log(error)
    }).finally(() => {
      commit('setLoading' , false)
    });
  },

  createNew({commit, dispatch }, payload) {
    ApiService
        .post(
            "/api/v2/dresscodes" , payload
        )
        .then(() => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: `Dress code created successfully`,
            showConfirmButton: false,
            timer: 2000
          })
        })
        .catch(error => {
          commit("setError", error);
        })
        .finally(() => {
          dispatch("fetchData");
        });
  },

  update({ commit , dispatch}, payload) {
    commit("setLoading", true);
    ApiService
        .update(
            "/api/v2/dresscodes", payload.id, payload.values
        )
        .then(() => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: `Dress code edited successfully`,
            showConfirmButton: false,
            timer: 2000
          })
        })
        .catch(error => {
          commit("setError", error);
        })
        .finally(() => {
          dispatch("fetchData");
          commit("setLoading", false)
        });
  },

  destroyData({commit, dispatch}, id) {
    ApiService
        .delete(
            "/api/v2/dresscodes/" + id
        )
        .then(() => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: `Dress code deleted successfully`,
            showConfirmButton: false,
            timer: 2000
          })
        })
        .catch(error => {
          commit("setError", error);
        })
        .finally(() => {
          dispatch("fetchData");
        });
  },
  resetPageNumber({commit}){
    commit('resetPageNumber')
  },
  setPageNumber({commit} , value){
    commit('setPageNumber', value)
  },
  resetState({ commit }) {
    commit("resetState");
  }
}
const mutations = {
  setDresscodesList(state, value) {
    state.dresscodesList = value
  },
  setError(state, value) {
    state.error = value
  },
  setLoading(state, value) {
    state.loading = value
  },
  setPagination(state, value) {
    state.pagination = value;
  },
  setPageNumber(state, value){
    state.pagination.current_page = value
  },
  resetState(state) {
    state = Object.assign(state, initialState())
  }
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
}
